import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import ModalControleDistribuicao from "components/modal/documentos/ModalControleDistribuicao";
import ModalDocumentoRelacionado from "components/modal/documentos/ModalDocumentoRelacionado";
import ModalDocumentoMover from "components/modal/documentos/pasta/ModalDocumentoMover";
import Documento from "model/documentos/Documento";
import DocumentoAssociacao from "model/documentos/DocumentoAssociacao";
import DocumentoVersao from "model/documentos/DocumentoVersao";
import DocumentoVersaoLocal from "model/documentos/DocumentoVersaoLocal";
import CategoriaDocumento from "model/documentos/CategoriaDocumento";
import Usuario from "model/administracao/cadastro/Usuario";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { DataTable, DataTableExpandedRows, DataTableValueArray } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { TabPanel, TabView } from "primereact/tabview";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import DocumentoService from "service/documentos/DocumentoService";
import DocumentoVersaoService from "service/documentos/DocumentoVersaoService";
import { converterData, converterDataHora } from "utils/convert";
import saveAs from 'file-saver';
import { Checkbox } from "primereact/checkbox";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { AutoComplete } from "primereact/autocomplete";
import { errorDecoder } from "utils/errorUtil";
import ModalDocumentoAlterarValidade from "components/modal/documentos/pasta/ModalDocumentoAlterarValidade";
import ModalDocumentoAlterarAlertaVencimento from "components/modal/documentos/pasta/ModalDocumentoAlterarAlertaVencimento";
import { usuarioCompleteMethod, usuarioItemTemplate } from "utils/autocompleteUtils";

const documentoService = new DocumentoService();
const documentoVersaoService = new DocumentoVersaoService();

export default function DocumentoPropriedades() {
    const navigate = useNavigate();
    const { msgSucesso, msgErro } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();
    const [titulo, setTitulo] = useState<string>('Documento');

    const [documento, setDocumento] = useState<Documento>(new Documento());
    const [categorias, setCategorias] = useState<CategoriaDocumento[]>([]);
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [usuariosFiltrados, setUsuariosFiltrados] = useState<Usuario[]>([]);

    const [documentosRelacionados, setDocumentosRelacionados] = useState<DocumentoAssociacao[]>([]);
    const [modalDocumentoAlterarPasta, setModalDocumentoAlterarPasta] = useState<{ visible: boolean, documento: Documento | null }>({ visible: false, documento: null });
    const [modalDocumentoAlterarValidade, setModalDocumentoAlterarValidade] = useState<{ visible: boolean, documento: Documento | null }>({ visible: false, documento: null });
    const [modalDocumentoAlterarAlertaVencimento, setModalDocumentoAlterarAlertaVencimento] = useState<{ visible: boolean, documento: Documento | null }>({ visible: false, documento: null });

    const [expandedRows, setExpandedRows] = useState<DataTableExpandedRows | DataTableValueArray | undefined>(undefined);

    function reterDocumentoLocal(rowData: any) {
        startLoading();
        documentoVersaoService.reterDistribuicao(rowData.id).then(() => {
            msgSucesso("Reter", 'Registro retido com sucesso!');
            load();
        }).catch((error) => {
            console.error(error);
            if (error && error.data && error.data.message) {
                msgErro(titulo, error.data.message);
            } else {
                msgErro(titulo, 'Ocorreu um erro ao tentar reter o registro, tente novamente!');
            }
        }).finally(() => {
            stopLoading();
        });
    }

    const rowExpansionTemplate = (versao: DocumentoVersao) => {
        return (
            <div className="p-3">
                <h5>Distribuições versão {versao.sequencial}</h5>
                <DataTable emptyMessage="Nenhuma distribuição encontrada" value={versao.locais} dataKey="id">
                    <Column field="local.nome" header="Local" ></Column>
                    <Column field="dataEntrada" header="Data" body={(rowData: DocumentoVersaoLocal) => converterData(rowData.dataEntrada)}></Column>
                    <Column field="copias" header="Cópias" ></Column>
                    <Column header="Retido" body={(rowData: DocumentoVersaoLocal) => <Checkbox checked={rowData.retido} />}></Column>
                    <Column body={(rowData) => {

                        return <>
                            <Button icon="pi pi-pencil" className="p-button-rounded p-button-info" onClick={() => {
                                const ultimaVersao = documento.versoes?.[documento.versoes.length - 1];
                                setModalControleDistribuicao({ visible: true, documentoVersao: ultimaVersao, documentoVersaoLocal: rowData as DocumentoVersaoLocal })
                            }} />
                            <Button icon="pi pi-trash" label="Reter" style={{ marginLeft: 8 }} className="p-button-rounded p-button-danger" onClick={() => {
                                confirmDialog({
                                    acceptLabel: 'Sim',
                                    rejectLabel: 'Não',
                                    message: 'Deseja realmente reter este registro?',
                                    header: 'Confirmação',
                                    icon: 'pi pi-exclamation-triangle',
                                    accept: (() => {
                                        reterDocumentoLocal(rowData);
                                    })
                                })
                            }} />
                        </>
                    }} />
                </DataTable>
            </div>
        );
    };
    const allowExpansion = (versao: DocumentoVersao) => {
        return versao.locais?.length > 0;
    };

    const [modalControleDistribuicao, setModalControleDistribuicao] = useState<{ visible: boolean, documentoVersao: DocumentoVersao | null, documentoVersaoLocal: DocumentoVersaoLocal | null }>({ visible: false, documentoVersao: null, documentoVersaoLocal: null });
    const [modalDocumentosRelacionados, setModalDocumentosRelacionados] = useState<{ visible: boolean, documento: Documento | null }>({ visible: false, documento: null });

    useEffect(() => {
        load();
        loadDocumentosRelacionados();
        documentoService.categorias().then(setCategorias).catch((error) => {
            console.error(error);
            msgErro("Erro", "Erro ao buscar categorias.");
        });
        documentoService.usuarios().then(setUsuarios).catch((error) => {
            console.error(error);
            msgErro("Erro", "Erro ao buscar usuários.");
        });
    }, [])

    function voltar() {
        navigate(-1);
    }

    function load() {
        startLoading();
        documentoService.consultar(parseInt(window.location.pathname.substring(`/documento/editar/`.length))).then((json) => {
            console.log(json)
            setDocumento(json);
            stopLoading();
        }).catch((error) => {
            console.error(error);
            stopLoading();
        })
    }

    function loadDocumentosRelacionados() {
        documentoService.documentosRelacionados(parseInt(window.location.pathname.substring(`/documento/editar/`.length))).then((response) => {
            setDocumentosRelacionados(response);
        }).catch((error) => {
            console.error("Erro ao buscar documentos associados:", error);
            msgErro("Erro", "Erro ao buscar documentos associados: " + error?.message || "")
        })
    }

    function gravarControles() {
        startLoading();
        documentoService.editarControles(documento).then((json) => {
            load();
            msgSucesso(titulo, 'Documento alterado com sucesso');
            stopLoading();
        }).catch((error) => {
            console.error(error);
            if (error && error.data && error.data.message) {
                msgErro(titulo, error.data.message);
            } else {
                msgErro(titulo, 'Ocorreu um erro ao tentar gravar, tente novamente!');
            }
            stopLoading();
        })
    }

    function gravarDadosGerais() {
        if (!documento.categoria?.id || !documento.codigoInterno?.trim() || !documento.nome?.trim()
            || !documento.internoExterno || !documento.usuarioResponsavel?.id) {
            msgErro(titulo, "Preencha todos os campos obrigatórios dos dados gerais.");
            return;
        }

        startLoading();
        documentoService.alterarDadosGerais({
            id: documento.id,
            categoria: documento.categoria,
            codigoInterno: documento.codigoInterno,
            nome: documento.nome,
            internoExterno: documento.internoExterno,
            usuarioResponsavel: documento.usuarioResponsavel
        }).then(() => {
            load();
            msgSucesso(titulo, "Dados gerais alterados com sucesso");
        }).catch((error) => {
            console.error(error);
            msgErro(titulo, error?.data?.message || "Ocorreu um erro ao tentar gravar, tente novamente!");
        }).finally(stopLoading);
    }

    type RemoverProps<T> = {
        item: T;
        funcaoExcluir: (id: string | number) => Promise<any>;
        getId: (item: T) => string | number | undefined;
        onSuccess?: () => void;
        titulo?: string;
    };

    function remover<T>({
        item,
        funcaoExcluir,
        getId,
        onSuccess,
        titulo = 'Registro'
    }: RemoverProps<T>) {
        confirmDialog({
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            message: 'Deseja realmente excluir este registro?',
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            accept: () => removerConfirm(item, funcaoExcluir, getId, onSuccess, titulo),
        });
    }

    function removerConfirm<T>(
        item: T,
        funcaoExcluir: (id: string | number) => Promise<any>,
        getId: (item: T) => string | number | undefined,
        onSuccess?: () => void,
        titulo = 'Registro'
    ) {
        const identificador = getId(item);

        if (identificador !== undefined) {
            funcaoExcluir(identificador)
                .then(() => {
                    msgSucesso(titulo, 'Registro removido com sucesso!');
                    if (onSuccess) onSuccess();
                })
                .catch(error => {
                    console.error(error);
                    if (error?.data?.message) {
                        msgErro(titulo, error.data.message);
                    } else {
                        msgErro(titulo, 'Ocorreu um erro ao tentar remover o registro, tente novamente!');
                    }
                });
        }
    }

    function imprimirVersao(versao: DocumentoVersao) {
        startLoading();

        documentoService.getCopiaControlada(versao.id || 0)
            .then(blob => {
                const fileURL = URL.createObjectURL(blob);
                const printWindow = window.open(fileURL, '_blank');
                if (printWindow) {
                    printWindow.addEventListener('load', () => {
                        printWindow.print();
                    });
                } else {
                    msgErro("Erro ao abrir janela de impressão", "Não foi possível abrir a janela de impressão. Verifique se o bloqueador de pop-ups está ativado.");
                }
            })
            .catch(async (e) => {
                let erro = await errorDecoder(e);
                msgErro("Erro", erro || "Erro ao imprimir documento");
                console.error(e)
            }).finally(() => {
                stopLoading();
            });
        return false;
    }

    const codigoKeyDown = (e: any) => {
        console.log(e.key)
        if (e.key === 'Enter') {
            console.log(documento.codigoInterno.substring(documento.categoria.prefixo.length))
            if (documento?.categoria.prefixo && !documento.codigoInterno.substring(documento.categoria.prefixo.length)) {
                documentoService.proximoCodigo(documento.categoria.id).then((data) => {
                    setDocumento({ ...documento, codigoInterno: String(data) });
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }

    return (
        <>
            <ConfirmDialog />

            {modalControleDistribuicao.visible && <ModalControleDistribuicao visible={modalControleDistribuicao.visible}
                onHide={() => {
                    setModalControleDistribuicao({ visible: false, documentoVersao: null, documentoVersaoLocal: null });
                    load();
                }}
                documentoVersao={modalControleDistribuicao.documentoVersao}
                documentoVersaoLocal={modalControleDistribuicao.documentoVersaoLocal}
            />}

            {modalDocumentosRelacionados.visible && <ModalDocumentoRelacionado visible={modalDocumentosRelacionados.visible}
                onHide={() => {
                    setModalDocumentosRelacionados({ visible: false, documento: null });
                    loadDocumentosRelacionados();
                }}
                documento={modalDocumentosRelacionados.documento}
            />}

            {modalDocumentoAlterarPasta.visible ?
                <ModalDocumentoMover visible={modalDocumentoAlterarPasta.visible}
                    onHide={() => {
                        setModalDocumentoAlterarPasta({ visible: false, documento: null });
                    }}
                    onConfirm={() => { load() }}
                    documento={modalDocumentoAlterarPasta.documento as Documento}
                />
                : null}

            {modalDocumentoAlterarValidade.visible ?
                <ModalDocumentoAlterarValidade visible={modalDocumentoAlterarValidade.visible}
                    onHide={() => {
                        setModalDocumentoAlterarValidade({ visible: false, documento: null });
                    }}
                    onConfirm={() => { load() }}
                    documento={modalDocumentoAlterarValidade.documento as Documento}
                />
                : null}

            {modalDocumentoAlterarAlertaVencimento.visible ?
                <ModalDocumentoAlterarAlertaVencimento visible={modalDocumentoAlterarAlertaVencimento.visible}
                    onHide={() => setModalDocumentoAlterarAlertaVencimento({ visible: false, documento: null })}
                    onConfirm={() => { load() }}
                    documento={modalDocumentoAlterarAlertaVencimento.documento as Documento}
                />
                : null}

            <TabView>
                <TabPanel header="Dados Gerais">
                    <Label className="col col-sm-12" obrigatorio>Categoria</Label>
                    <div className="col-sm-12">
                        <Dropdown
                            options={categorias}
                            optionLabel="nome"
                            value={documento.categoria}
                            onChange={(e) => setDocumento({
                                ...documento,
                                categoria: e.value,
                                codigoInterno: e.value.prefixo + documento.codigoInterno.substring(documento.categoria?.prefixo?.length || 0)
                            })}
                            style={{ width: '100%' }}
                        />
                    </div>

                    <div style={{ display: 'flex', flexDirection: "column", marginTop: 12 }}>
                        <Label className="col col-sm-12" obrigatorio>Documento</Label>
                        <div className="col-sm-12">
                            <div style={{ display: 'flex' }}>
                                <div style={{ border: "1px solid #a6a6a6", display: "flex", alignItems: "center", justifyContent: "center", borderBottomLeftRadius: 3, borderTopLeftRadius: 3, width: "100px", backgroundColor: "#fff" }}>
                                    <span style={{ color: "#a6a6a6", fontSize: 16 }}>{documento.categoria?.prefixo || ""}</span>
                                </div>
                                <InputText
                                    onKeyDown={codigoKeyDown}
                                    value={documento.codigoInterno.substring(documento.categoria?.prefixo?.length || 0)}
                                    onChange={(e) => setDocumento({ ...documento, codigoInterno: (documento.categoria?.prefixo || "") + e.target.value })}
                                    style={{ width: '200px', marginLeft: -1, borderBottomLeftRadius: 0, borderTopLeftRadius: 0 }}
                                />
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: "column", marginTop: 12 }}>
                        <Label className="col col-sm-12" obrigatorio>Nome</Label>
                        <div className="col-sm-12">
                            <InputText style={{ width: '30%' }} value={documento.nome}
                                onChange={(e) => setDocumento({ ...documento, nome: e.target.value })} />
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: "column", marginTop: 12 }}>
                        <Label className="col col-sm-12" obrigatorio>Interno/Externo</Label>
                        <div className="col-sm-12">
                            <Dropdown
                                options={[{ value: "INTERNO", label: "Interno" }, { value: "EXTERNO", label: "Externo" }]}
                                optionValue="value"
                                optionLabel="label"
                                value={documento.internoExterno}
                                onChange={(e) => setDocumento({ ...documento, internoExterno: e.value })}
                                style={{ width: '100%' }}
                            />
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: "column", marginTop: 12 }}>
                        <Label className="col col-sm-12" obrigatorio>Responsável</Label>
                        <div className="col-sm-12">
                            <AutoComplete
                                dropdown
                                value={documento.usuarioResponsavel}
                                placeholder="Selecione um Usuário"
                                style={{ width: '100%' }}
                                field="nome"
                                itemTemplate={(item: Usuario) => usuarioItemTemplate(item)}
                                suggestions={usuariosFiltrados}
                                completeMethod={(e) => setUsuariosFiltrados(usuarioCompleteMethod(usuarios, e.query))}
                                onChange={(e) => setDocumento({
                                    ...documento,
                                    usuarioResponsavel: typeof e.value === "string"
                                        ? Object.assign(new Usuario(), { nome: e.value })
                                        : e.value
                                })}
                            />
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: "column", marginTop: 12 }}>
                        <Label className="col col-sm-12">Pasta Mãe</Label>
                        <div className="col-sm-12">
                            <InputText style={{ width: 400 }} value={documento.pastaMae?.nome || "(Raiz)"} readOnly />
                            <Button type="button" icon={<FontAwesomeIcon icon="pencil-alt" />} className="ui-button-info" style={{ marginLeft: 8 }}
                                onClick={() => { setModalDocumentoAlterarPasta({ visible: true, documento: documento }); }}>
                            </Button>
                        </div>
                    </div>

                    <div style={{ display: 'flex', marginTop: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'center', columnGap: 8, width: 250 }}>
                            <Checkbox checked={documento.controlaPrazo} disabled />
                            <label className="col col-sm-12">Controla prazo de validade</label>
                        </div>
                        <div >
                            <Label className="col col-sm-12" style={{ fontWeight: 700, color: documento.controlaPrazo ? "#000" : "#777" }}>Prazo de validade (meses)</Label>
                            <div className="col-sm-12">
                                <InputNumber
                                    disabled
                                    value={documento.mesesPrazo}
                                />
                                <Button type="button" icon={<FontAwesomeIcon icon="pencil-alt" />} className="ui-button-info" style={{ marginLeft: 8 }}
                                    onClick={() => setModalDocumentoAlterarValidade({ visible: true, documento })}
                                />
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', marginTop: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'center', columnGap: 8, width: 250 }}>
                            <Checkbox checked={documento.alertaVencimento} disabled />
                            <label className="col col-sm-12">Alerta vencimento</label>
                        </div>
                        <div >
                            <Label className="col col-sm-12" style={{ fontWeight: 700, color: documento.alertaVencimento ? "#000" : "#777" }}>Dias para alerta de vencimento</Label>
                            <div className="col-sm-12">
                                <InputNumber
                                    disabled
                                    value={documento.diasAlertaVencimento}
                                />
                                <Button type="button" icon={<FontAwesomeIcon icon="pencil-alt" />} className="ui-button-info" style={{ marginLeft: 8 }}
                                    onClick={() => setModalDocumentoAlterarAlertaVencimento({ visible: true, documento })}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div style={{ textAlign: 'right', whiteSpace: 'nowrap', marginTop: 12 }}>
                            <Button type="button" label="Gravar Dados gerais" className="ui-button-info" onClick={gravarDadosGerais} />
                        </div>
                    </div>

                </TabPanel>

                <TabPanel header="Controle">
                    <div className="row">
                        <Label className="col col-sm-12">Disposição</Label>
                        <div className="col-sm-12">
                            <InputTextarea
                                value={documento.disposicao}
                                style={{ width: '100%' }}
                                onChange={(e) => setDocumento({ ...documento, disposicao: e.target.value })}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <Label className="col col-sm-12">Retenção</Label>
                        <div className="col-sm-12">
                            <InputTextarea
                                value={documento.retencao}
                                style={{ width: '100%' }}
                                onChange={(e) => setDocumento({ ...documento, retencao: e.target.value })}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12">Recuperação</Label>
                        <div className="col-sm-12">
                            <InputTextarea
                                value={documento.recuperacao}
                                style={{ width: '100%' }}
                                onChange={(e) => setDocumento({ ...documento, recuperacao: e.target.value })}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12">Proteção</Label>
                        <div className="col-sm-12">
                            <InputTextarea
                                value={documento.protecao}
                                style={{ width: '100%' }}
                                onChange={(e) => setDocumento({ ...documento, protecao: e.target.value })}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12">Armazenamento</Label>
                        <div className="col-sm-12">
                            <InputTextarea
                                value={documento.armazenamento}
                                style={{ width: '100%' }}
                                onChange={(e) => setDocumento({ ...documento, armazenamento: e.target.value })}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <Label className="col col-sm-12">Forma de acesso</Label>
                        <div className="col-sm-12">
                            <InputTextarea
                                value={documento.formaAcesso}
                                style={{ width: '100%' }}
                                onChange={(e) => setDocumento({ ...documento, formaAcesso: e.target.value })}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div style={{ textAlign: 'right', whiteSpace: 'nowrap', marginTop: 2 }}>
                            <Button type="button" label="Gravar controles" className="ui-button-info" style={{ marginLeft: 8 }} onClick={() => gravarControles()}></Button>
                        </div>
                    </div>
                </TabPanel>

                <TabPanel header="Distribuição">
                    <DataTable
                        emptyMessage="Nenhuma versão encontrada"
                        value={documento.versoes} expandedRows={expandedRows} rowExpansionTemplate={rowExpansionTemplate}
                        dataKey="sequencial" onRowToggle={(e) => setExpandedRows(e.data)}
                        header={<div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                            <div></div>
                            <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>{titulo}</span>
                            <div>
                                <Button
                                    type="button" icon={<FontAwesomeIcon icon="add" />}
                                    className="ui-button-info"
                                    onClick={() => {
                                        const ultimaVersao = documento.versoes?.[documento.versoes.length - 1];
                                        setModalControleDistribuicao({ visible: true, documentoVersao: ultimaVersao, documentoVersaoLocal: null })
                                    }}
                                ></Button>
                            </div>
                        </div>}>
                        <Column expander={allowExpansion} style={{ width: '5rem' }} />
                        <Column field="sequencial" header="Versão"></Column>
                        <Column field="status" header="Status" body={(rowData: DocumentoVersao) => documentoVersaoService.getStatus(rowData.status)}></Column>
                        <Column field="usuarioResponsavel.nome" header="Responsável"></Column>
                        <Column style={{ width: 150 }} body={(rowData: DocumentoVersao) => {
                            if (rowData.status === 'PUBLICADO') {
                                return <Button label="Imprimir" icon="pi pi-print" onClick={() => {
                                    imprimirVersao(rowData);
                                }} />
                            }
                        }} />
                    </DataTable>
                </TabPanel>

                <TabPanel header="Histórico">
                    <div>
                        {documento.itensHistorico.map((item, index) => (
                            <div key={index} style={{ display: 'flex', flexDirection: "column", borderBottom: '1px solid #ddd', padding: '8px 0' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span style={{ width: '50%', fontWeight: 700 }}>{item.usuario?.nome}</span>
                                    <span style={{ width: '50%', textAlign: "right", fontSize: '12pt', color: "#999" }}>{converterDataHora(item.data)}</span>
                                </div>
                                <span style={{ width: '40%' }}>{item.descricao}</span>
                            </div>
                        ))}
                    </div>
                </TabPanel>

                <TabPanel header="Versões">
                    <DataTable value={documento.versoes} dataKey="sequencial"
                        emptyMessage="Nenhuma versão encontrada"
                    >
                        <Column field="sequencial" header="Versão"></Column>
                        <Column field="dataPublicacao" header="Data Publicação" body={(rowData: DocumentoVersao) => converterData(rowData.dataPublicacao)}></Column>
                        <Column field="usuarioResponsavel.nome" header="Responsável"></Column>
                        <Column field="status" header="Status" body={(rowData: DocumentoVersao) => documentoVersaoService.getStatus(rowData.status)}></Column>
                        <Column style={{ width: '5%' }} body={(rowData) => {
                            return <Button type="button" tooltip="Fluxo" tooltipOptions={{ position: "top" }} icon={<FontAwesomeIcon icon="diagram-project" />} className="ui-button-info" style={{ marginLeft: 8 }}
                                onClick={() => {
                                    navigate(`/documentoVersao/editar/${rowData.id}`);
                                }}></Button>
                        }} />
                        <Column style={{ width: '5%' }} body={(rowData: DocumentoVersao) => {
                            return <Button type="button" tooltip="Baixar" tooltipOptions={{ position: "top" }} icon={<FontAwesomeIcon icon="download" />} className="ui-button-info" style={{ marginLeft: 8 }}
                                onClick={() => {
                                    console.log(rowData.arquivo)
                                    fetch(rowData?.arquivo?.url || "")
                                        .then(res => res.blob())
                                        .then(blob => saveAs(blob, documento.nome + ` - v${rowData.sequencial}.` + rowData.arquivo?.nome.split('.').pop()))
                                        .catch(e => {
                                            console.error(e)
                                        });
                                }}></Button>
                        }} />
                    </DataTable>
                </TabPanel>

                <TabPanel header="Documentos relacionados">
                    <DataTable
                        emptyMessage="Nenhum resultado encontrado"
                        value={documentosRelacionados} dataKey="id"
                        header={<div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                            <div></div>
                            <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>{titulo}</span>
                            <div>
                                <Button
                                    type="button" icon={<FontAwesomeIcon icon="add" />}
                                    className="ui-button-info"
                                    onClick={() => {
                                        setModalDocumentosRelacionados({ visible: true, documento: documento })
                                    }}
                                ></Button>
                            </div>
                        </div>}>
                        <Column field="documentoAssociado.nome" header="Documento Relacionado"></Column>
                        <Column style={{ width: '5%' }} body={(rowData) => {
                            return <Button type="button" icon={<FontAwesomeIcon icon="remove" />} className="ui-button-danger" style={{ marginLeft: 8 }}
                                onClick={() => {
                                    remover({
                                        item: rowData,
                                        funcaoExcluir: (id) => documentoService.excluirDocumentoRelacionado(id as number),
                                        getId: (item) => item.id,
                                        titulo: 'Documento Relacionado',
                                        onSuccess: () => { loadDocumentosRelacionados() }
                                    })
                                }}></Button>
                        }} />
                    </DataTable>
                </TabPanel>
            </TabView>

            <div className="row">
                <div style={{ textAlign: 'right', whiteSpace: 'nowrap', marginTop: 2 }}>
                    <Button type="button" label="Voltar" className="ui-button-info" onClick={() => voltar()}></Button>
                </div>
            </div>
        </>
    )
}
